'use client'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { getLatestBlogs, getSocials, type BlogPost, type Social } from '@/lib/api'

export default function Footer() {
  const [news, setNews] = useState<BlogPost[]>([])
  const [socials, setSocials] = useState<Social[]>([])

  useEffect(() => {
    getLatestBlogs().then(b => setNews((b || []).slice(0, 3)))
    getSocials().then(s => setSocials(s || []))
  }, [])

  const latestNews = news.length > 0
    ? news.map(b => ({ title: b.title, date: b.created_at }))
    : [
        { title: 'Fly High With Our Exclusive Travel Tips', date: '24/08/2024' },
        { title: 'Fly High With Our Exclusive Travel Tips', date: '24/08/2024' },
        { title: 'Fly High With Our Exclusive Travel Tips', date: '24/08/2024' },
      ]

  return (
    <footer style={{ background: 'linear-gradient(105deg, #01061a 0%, #04162f 42%, #053a86 100%)', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '56px 40px 32px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '40px', marginBottom: '40px' }}>

          {/* About Us */}
          <div>
            <h4 style={{ fontSize: '13px', fontWeight: 800, color: '#fff', letterSpacing: '0.10em', marginBottom: '16px' }}>About Us</h4>
            <p style={{ fontSize: '11.5px', color: 'rgba(255,255,255,0.42)', lineHeight: 1.85, marginBottom: '16px' }}>
              Mohammad Ghassan Is An Experienced Entrepreneur In Business Development And Strategic Planning.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '11px', color: 'rgba(255,255,255,0.42)' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.42)" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                Al-Manhal, Dubai / Abu Dhabi
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '11px', color: '#f97316' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                ghassan@alrifai.com
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '11px', color: 'rgba(255,255,255,0.42)' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.42)" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.62a16 16 0 0 0 6 6l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16z"/></svg>
                +968 6334 634
              </div>
            </div>
          </div>

          {/* Latest News */}
          <div>
            <h4 style={{ fontSize: '13px', fontWeight: 800, color: '#fff', letterSpacing: '0.10em', marginBottom: '16px' }}>Latest News</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {latestNews.map((item, i) => (
                <Link key={i} href="/blog" style={{ textDecoration: 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                    <span style={{ color: '#f97316', fontSize: '10px', marginTop: '2px', flexShrink: 0 }}>▶</span>
                    <div>
                      <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.48)', lineHeight: 1.6, marginBottom: '3px' }}>{item.title}</p>
                      <p style={{ fontSize: '10px', color: 'rgba(249,115,22,0.65)' }}>{item.date}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Follow Alrifai */}
          <div>
            <h4 style={{ fontSize: '13px', fontWeight: 800, color: '#fff', letterSpacing: '0.10em', marginBottom: '16px' }}>Follow Alrifai</h4>
            <div style={{ borderRadius: '4px', overflow: 'hidden', marginBottom: '14px', height: '110px' }}>
              <img src="/ghassan-profile.jpg" alt="Ghassan" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top', opacity: 0.82 }} />
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              {socials.length > 0 ? socials.map(s => (
                <a key={s.id} href={s.link} target="_blank" rel="noopener noreferrer"
                  style={{ width: '30px', height: '30px', borderRadius: '4px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.14)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                  <img src={s.icon} alt="" style={{ width: '14px', height: '14px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} onError={(e:any)=>{e.currentTarget.style.display='none'}} />
                </a>
              )) : [
                { label: 'X', icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="white"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.259 5.629L18.244 2.25z"/></svg> },
                { label: 'in', icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="white"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg> },
                { label: 'ig', icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1" fill="white" stroke="none"/></svg> },
                { label: 'fb', icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="white"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg> },
                { label: 'sk', icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg> },
              ].map(s => (
                <a key={s.label} href="#" style={{ width: '30px', height: '30px', borderRadius: '4px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.14)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.32)' }}>Mohammad Ghassan Al-Rifai Personal WebSite 2024. All Rights Reserved.</span>
          <div style={{ display: 'flex', gap: '20px' }}>
            {['Terms & Conditions', 'Privacy Policies', 'Cookie Policy'].map(t => (
              <Link key={t} href="#" style={{ fontSize: '11px', color: 'rgba(255,255,255,0.32)', textDecoration: 'none' }}>{t}</Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
